import React from 'react';

import { useIntl } from 'react-intl-next';
import { useDispatch, useSelector } from 'react-redux';

import { Box, xcss } from '@atlaskit/primitives';
import SectionMessage, {
  SectionMessageAction,
} from '@atlaskit/section-message';

import { openDialog } from 'src/redux/pull-request/merge-reducer';
import { getPullRequestCanCurrentUserMerge } from 'src/redux/pull-request/selectors';

import { useMergeData } from '../../hooks/merge-data';
import { BasicMergeChecksList } from '../merge-checks-card';

import messages from './pull-request-state-message.i18n';
import { StateMessageWrapper } from './pull-request-state-message.style';

export const AllChecksPassedMessage = () => {
  const { formatMessage } = useIntl();
  const canCurrentUserMerge = useSelector(getPullRequestCanCurrentUserMerge);
  const dispatch = useDispatch();
  const { classicChecksCount, forgeMergeChecksData } = useMergeData();

  const onMergeChecksCount =
    forgeMergeChecksData?.enabledOnMergeChecks.enabledChecks?.length ?? 0;
  const hasOnMergeChecks = onMergeChecksCount > 0;

  const actions = canCurrentUserMerge
    ? [
        <SectionMessageAction
          key="merge-dialog"
          onClick={() => dispatch(openDialog())}
          testId="mergePullRequestLink"
        >
          {formatMessage(messages.mergePullRequestLink)}
        </SectionMessageAction>,
      ]
    : undefined;

  const renderDescription = () => {
    const preMergeChecksTotal =
      classicChecksCount + (forgeMergeChecksData?.preMergeChecksCount ?? 0);
    const onMergeChecksDescription = hasOnMergeChecks
      ? formatMessage(
          messages.readyToMergePullRequestOnMergeChecksDescription,
          { checksCount: onMergeChecksCount }
        )
      : '';

    if (preMergeChecksTotal > 0) {
      return formatMessage(
        messages.readyToMergePullRequestDescriptionWithChecks,
        {
          required: <strong>{formatMessage(messages.required)}</strong>,
          onMergeChecksDescription,
        }
      );
    } else {
      return onMergeChecksDescription;
    }
  };

  return (
    <StateMessageWrapper>
      <SectionMessage
        appearance="information"
        title={formatMessage(messages.readyToMergePullRequestStateMessage)}
        actions={actions}
      >
        {renderDescription()}
        {hasOnMergeChecks && (
          <Box xcss={xcss({ marginTop: 'space.050' })}>
            <BasicMergeChecksList
              customMergeCheckResults={
                forgeMergeChecksData?.enabledOnMergeChecks?.enabledChecks ?? []
              }
            />
          </Box>
        )}
      </SectionMessage>
    </StateMessageWrapper>
  );
};
